/* eslint-disable no-plusplus */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import shallow from 'zustand/shallow';
import styled from 'styled-components';
import { IonSpinner } from '@ionic/react';
import videojs, { VideoJsPlayer } from 'video.js';
import { FocusScope } from '@react-aria/focus';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/city/index.css';
import '@videojs/themes/dist/forest/index.css';
import '@videojs/themes/dist/sea/index.css';
import 'videojs-markers';
import 'videojs-markers/dist/videojs.markers.css';
import ReactDOM from 'react-dom';
import { VideoWrapper } from '../styles/VideoWrapper';
import { EpisodeVideoPrompt } from './EpisodeVideoPrompt';
import {
  Prompt,
  Marker,
  User,
  EpisodeSection,
  PromptCollection,
} from '../../../@types';
// import { registerVideoJsMarkersPlugin } from './EpisodeVideoMarkers';
import '../styles/EpisodeVideo.css';
import * as Constants from '../../../constants';
import { useEpisodeStore } from '../../../store';
import {
  useCurrentUser,
  usePrompts,
  useSaveUserProgress,
  useUserSectionProgress,
} from '../../../api';
import { useRole } from '../../../hooks';
import { Marker as MarkerComponent } from './Marker';

// videojs.registerPlugin('markers', registerVideoJsMarkersPlugin);

declare module 'video.js' {
  interface VideoJsPlayer {
    markers: any;
  }
}

interface EpisodeVideoProps {
  section: EpisodeSection;
  initial_timestamp: number;
}

const videoJSOptions = {
  autoplay: false,
  fluid: true,
  controls: true,
  muted: false,
  volume: 0.4,
  userActions: { hotkeys: true },
  playbackRates: [0.5, 1, 1.5, 2],
};

const Overlay = styled.div`
  background: #3b587a9c;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  position: absolute;
  visibility: hidden;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.4s, transform 0.2s, visibility 0s;
  transform: translateY(700px) scale(0.8);
  background: linear-gradient(
    -45deg,
    #ee7752cc,
    #e73c7eab,
    #23a6d5d9,
    #23d5ab96
  );
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
  &.starting-fade {
    background: #000;
    visibility: visible;
    pointer-events: none;
    opacity: 0;
    transition: opacity 1s;
    transform: translateY(0) scale(1);
    z-index: 15;
  }
  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) scale(1);
    z-index: 25;
  }
`;

export const EpisodeVideoBase: React.FC<EpisodeVideoProps> = ({
  section,
  initial_timestamp,
}) => {
  const { video_src: video } = section;
  if (!video) {
    return null;
  }
  const { data: user } = useCurrentUser();

  const { data: prompts, isLoading }: any = usePrompts(section.id);

  const {
    data: sectionProgress,
    isLoading: progressLoading,
  }: any = useUserSectionProgress((user && user.id) || '', section.id);

  const { mutateAsync: saveUserProgress } = useSaveUserProgress(section.id);

  const { showEndScreen, EPISODE_ACTIONS, PROMPT_ACTIONS } = useEpisodeStore(
    (state) => ({
      showEndScreen: state.showEndScreen,
      EPISODE_ACTIONS: state.EPISODE_ACTIONS,
      PROMPT_ACTIONS: state.PROMPT_ACTIONS,
    }),
    shallow
  );
  const sectionPrompts = useEpisodeStore((state) => state.sectionPrompts);
  const sectionPromptsRef = useRef(useEpisodeStore.getState().sectionPrompts);
  const currentTimeRef = useRef(
    useEpisodeStore.getState().progress.current_timestamp
  );
  useEffect(
    () =>
      useEpisodeStore.subscribe(
        (current_timestamp: any) =>
          (currentTimeRef.current = current_timestamp),
        (state) => state.progress.current_timestamp
      ),
    []
  );

  const videoPlayerRef = useRef<VideoJsPlayer | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [player, setPlayer] = useState<VideoJsPlayer | null>(null);
  const [doneLoading, setDoneLoading] = useState<boolean>(false);
  const [isBeginning, setIsBeginning] = useState<boolean>(false);
  const [isPausedOnQuestion, setPausedOnQuestion] = useState<boolean>(false);
  const [marketCreated, setMarkerCreated] = useState(false);
  const { userRole } = useRole();
  const { isTeacher = false, isAdmin = false } = userRole || {};

  const isPromptCompleted = (promptId: string, _prompts: any[]) => {
    return !!_prompts.filter((p: any) => p.prompt_id === promptId)[0].completed;
  };

  const isPromptOpen = (promptId: string) => {
    return !!sectionPromptsRef.current.find(
      (p: any) => p.prompt.id === promptId
    )?.isOpen;
  };

  function getMarkerElement(
    time: string,
    _player: VideoJsPlayer
  ): Element | null {
    return _player
      .el()
      .querySelector(`.vjs-marker[data-marker-time="${time}"]`);
  }

  function getPromptIfExists(
    timestamp: string,
    ignoreCompleted = false
  ): Prompt | false {
    if (timestamp in prompts) {
      if (
        ignoreCompleted ||
        !isPromptCompleted(prompts[timestamp].id, sectionProgress.prompts)
      ) {
        return prompts[timestamp];
      }
    }
    return false;
  }

  function markPromptCompleted(timestamp: string): void {
    if (player) {
      const marker = getMarkerElement(timestamp, player);
      if (timestamp in prompts) {
        // prompts[timestamp].completed = true;
      }
      if (marker) {
        marker.classList.add('vjs-marker-completed');
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handleCreateMarkets = (_player: VideoJsPlayer) => {
    setMarkerCreated(true);
    const elements = document.getElementsByClassName('vjs-marker');
    const promptsOrdered = Object.values(prompts).sort(
      (a: any, b: any) => a.timestamp - b.timestamp
    );

    // console.log(elements);
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (!element.hasChildNodes()) {
        const iconBox = document.createElement('div');
        const currentPrompt = promptsOrdered[i];
        iconBox.style.position = 'absolute';
        iconBox.style.top = '-40px';
        iconBox.style.left = '-19px';
        iconBox.style.zIndex = '1000';
        ReactDOM.render(
          <MarkerComponent
            prompt={currentPrompt}
            onClick={() => _player.currentTime(12)}
          />,
          iconBox
        );
        element.appendChild(iconBox);
      }
    }
  };
  function closePrompt(prompt: Prompt): void {
    setPausedOnQuestion(false);
    PROMPT_ACTIONS.setIsOpen(prompt.id, false);
    prompt.completed = true;
    prompt.closedAt = Math.floor(new Date().getTime() / 1000);
    if (player) {
      player.removeClass('vjs-controls-disabled');

      const marker = getMarkerElement(prompt.timestamp.toString(), player);
      if (marker) {
        marker.classList.remove('vjs-marker-active');
      }
      if (player.paused()) {
        player.play();
      }
    }
  }

  function closeAllPrompts(ignoreSpecific: Prompt | false = false): void {
    sectionPrompts.forEach((state) => {
      const { prompt, isOpen } = state;
      if (
        prompt &&
        isOpen &&
        (!ignoreSpecific || ignoreSpecific.timestamp !== prompt.timestamp)
      ) {
        closePrompt(prompt);
      }
    });
  }

  function restartPromptTimeoutsAfterPause() {
    sectionPrompts.forEach((state) => {
      const { prompt, isOpen } = state;
      if (prompt && isOpen) {
        const displayTime = prompt.display_time
          ? prompt.display_time * 1000
          : false;
        if (player && displayTime) {
          const endTime = displayTime + prompt.timestamp;
          const remainingTime =
            player.currentTime() < endTime
              ? (endTime - player.currentTime()) * 1000
              : 0;
          setTimeout(() => {
            if (player && !player.paused()) {
              closePrompt(prompt);
            }
          }, remainingTime);
        } else {
          closePrompt(prompt);
        }
      }
    });
  }

  // function deactivateMarkers(_player: VideoJsPlayer): void {
  //   sectionPrompts.forEach((state) => {
  //     const { prompt, isOpen } = state;
  //     if (prompt && !isOpen) {
  //       const markerDiv = getMarkerElement(
  //         prompt.timestamp.toString(),
  //         _player
  //       );
  //       if (markerDiv) {
  //         markerDiv.classList.remove('vjs-marker-active');
  //       }
  //     }
  //   });
  // }

  // function setActiveMarker(marker: Element | null) {
  //   if (player) {
  //     deactivateMarkers(player); // Deactivate all markers before activating the requested one
  //     if (marker) {
  //       setTimeout(() => {
  //         marker.classList.add('vjs-marker-active');
  //       }, 10);
  //     }
  //   }
  // }

  async function openPrompt(prompt: Prompt, _player: VideoJsPlayer) {
    closeAllPrompts(prompt);
    // const marker = getMarkerElement(prompt.timestamp.toString(), _player);
    // setActiveMarker(marker);
    // markPromptCompleted(prompt.timestamp.toString());
    const displayTime = prompt.display_time
      ? prompt.display_time * 1000
      : false;

    const isQuestion =
      prompt.prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION;
    const twoSecondsAgo = Math.floor(new Date().getTime() / 1000) - 2;
    const recentlyClosed = prompt.closedAt && prompt.closedAt > twoSecondsAgo;

    if (user) {
      if (!isPromptCompleted(prompt.id, sectionProgress.prompts)) {
        await saveUserProgress({
          prompt_id: prompt.id,
          user_id: user.id,
        });
      }
    }

    if (!recentlyClosed) {
      PROMPT_ACTIONS.setIsOpen(prompt.id, true);
      if (!displayTime || isQuestion) {
        _player.removeClass('vjs-controls-disabled');
        _player.pause();
        if (prompt.prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION) {
          setTimeout(() => {
            setPausedOnQuestion(true);
          }, 10);
        }
      } else {
        _player.removeClass('vjs-controls-disabled');
        _player.play();
        setTimeout(() => {
          if (!_player.paused()) {
            closePrompt(prompt);
          }
        }, displayTime);
      }
    }
  }

  // function handleMarkerClick(marker: Marker) {
  //   const prompt = getPromptIfExists(marker.time.toString(), true);
  //   if (prompt && player) {
  //     openPrompt(prompt, player);
  //   }
  // }

  function registerPlayerModals(_player: VideoJsPlayer) {
    const markers: Marker[] = [];

    sectionPrompts.forEach((state) => {
      const { prompt } = state;
      // Add marker
      if (prompt) {
        // markers.push({
        //     time: +prompt.timestamp,
        //     text: prompt.text,
        //     completed: prompt.completed,
        //     class: `${prompt.completed ? 'vjs-marker-completed' : ''}`,
        // });

        if (prompt.completed) {
          markPromptCompleted(prompt.timestamp.toString());
        }
      }
    });

    // _player.markers({
    //   markers,
    //   onMarkerClick: (marker: Marker) => {
    //     handleMarkerClick(marker);
    //   },
    //   onMarkerReached: (marker: Marker, index: number) => {},
    // });
  }

  function getMarkerByTimestamp(
    timestamp: number,
    _player: VideoJsPlayer
  ): Marker | false {
    const allMarkers = _player.markers.getMarkers();
    let marker: Marker | false = false;

    allMarkers.forEach((_marker: Marker) => {
      if (_marker.time === timestamp) {
        marker = _marker;
      }
    });
    return marker;
  }

  function getPromptFromTimestamp(): Prompt | false {
    if (player) {
      const timestamp = Math.floor(player.currentTime()).toString();
      return getPromptIfExists(timestamp, true);
    }
    return false;
  }

  useEffect(() => {
    if (player) {
      if (showEndScreen) {
        player.addClass('vjs-controls-disabled');
        player.addClass('show-end-screen');
      } else {
        player.removeClass('vjs-controls-disabled');
        player.removeClass('show-end-screen');
      }
    }
  }, [showEndScreen]);

  const updateProgress = useCallback(
    (timestamp) => {
      const time = currentTimeRef.current;
      if (time !== undefined && timestamp > time) {
        EPISODE_ACTIONS.setProgress(section.id, timestamp);
      }
    },
    [currentTimeRef.current]
  );

  // console.log('re-rendered base');
  useEffect(() => {
    if (!player) {
      return;
    }
    useEpisodeStore.subscribe(
      (state) => (sectionPromptsRef.current = state.sectionPrompts)
    );
    const filteredPrompts = Object.values(prompts).filter((prompt: any) => {
      const completed =
        sectionProgress &&
        isPromptCompleted(prompt.id, sectionProgress?.prompts);
      const visible = isTeacher || isAdmin || completed;
      return visible;
    });

    const promptsOrdered = filteredPrompts.sort(
      (a: any, b: any) => a.timestamp - b.timestamp
    );
    player.markers({
      markerStyle: {
        width: '2px',
        'background-color': 'white',
      },
      markerTip: {
        display: false,
      },
      breakOverlay: {
        display: false,
      },
      markers: promptsOrdered.map((prompt: any) => {
        return {
          time: prompt.timestamp,
          text: prompt.title,
        };
      }),
    });

    player.currentTime(initial_timestamp);

    if (user) {
      registerPlayerModals(player);

      // setTimeout(() => {
      //     Object.keys(prompts).forEach((key) => {
      //         const prompt = prompts[key];
      //         if (prompt.completed) {
      //             markPromptCompleted(prompt.timestamp.toString());
      //         }
      //     });
      // }, 100);
    }

    player.on('play', () => {
      setPausedOnQuestion(false);
      player.removeClass('vjs-controls-disabled');

      setTimeout(() => {
        if (!player.paused()) {
          restartPromptTimeoutsAfterPause();
        }
      }, 10);
      setTimeout(() => {
        setIsBeginning(false);
      }, 1000);
    });

    player.on('seeking', () => {
      player.pause();
      const prompt = getPromptFromTimestamp();
      if (prompt && !prompt.shouldPause) {
        // prompt.forcePaused = true;
      }
    });

    player.on('timeupdate', () => {
      const prompt = getPromptFromTimestamp();
      const timestamp = Math.floor(player.currentTime());
      const time = currentTimeRef.current;

      if (!marketCreated) {
        handleCreateMarkets(player);
      }

      if (time !== undefined && timestamp > time) {
        // updateProgress(timestamp);
      }
      if (!prompt) {
        // deactivateMarkers(player);
        return;
      }

      const markers = player.markers.getMarkers();
      const found = markers.find(
        (marker: any) => marker.time === prompt.timestamp
      );
      if (!found) {
        player.markers.add([
          {
            time: prompt.timestamp,
            text: prompt.title,
          },
        ]);
        handleCreateMarkets(player);
      }
      // updateProgress(timestamp);
      if (!isPromptOpen(prompt.id)) {
        openPrompt(prompt, player);
      }
    });

    player.on('ended', () => {
      EPISODE_ACTIONS.setShowEndScreen(true);
    });

    player.on('seeked', () => {
      const prompt = getPromptFromTimestamp();
      player.pause();

      if (!prompt) {
        closeAllPrompts();
        setPausedOnQuestion(false);
        player.removeClass('vjs-controls-disabled');

        // deactivateMarkers(player);
      } else if (prompt.prompt_type_id === Constants.PROMPT_TYPE_IDS.QUESTION) {
        setTimeout(() => {
          setPausedOnQuestion(true);
        }, 10);
      }
      // const promptMarker = getMarkerByTimestamp(prompt.timestamp, player);
      // if (promptMarker && promptMarker.time) {
      //   setActiveMarker(
      //     getMarkerElement(promptMarker.time.toString(), player)
      //   );
      // }
    });
  }, [player]);

  useEffect(() => {
    if (videoRef.current) {
      if (isPausedOnQuestion) {
        videoRef.current.classList.add('blur');
      } else {
        videoRef.current.classList.remove('blur');
      }
    }
  }, [isPausedOnQuestion]);

  useEffect(() => {
    if (player && user) {
      registerPlayerModals(player);
    }
  }, [user]);

  useEffect(() => {
    if (doneLoading) {
      if (video && !videoPlayerRef.current) {
        const p = videojs(videoRef.current, videoJSOptions, () => {
          p.src(video);
          setPlayer(p);
          EPISODE_ACTIONS.setPlayer(p);
          p.volume(0.4);
        });
        videoPlayerRef.current = p;
        setIsBeginning(true);
        setPausedOnQuestion(true);
        return () => {
          if (videoPlayerRef.current) {
            videoPlayerRef.current.dispose();
            videoPlayerRef.current = null;
          }
          setPlayer(null);
        };
      }
    }
    return () => {};
  }, [doneLoading]);

  useEffect(() => {
    if (!progressLoading && !isLoading) {
      EPISODE_ACTIONS.setPrompts(prompts);
      setDoneLoading(true);
    }
  }, [prompts, sectionProgress]);

  return (
    <VideoWrapper>
      <div data-vjs-player>
        {!isBeginning && player && (
          <Overlay className={isPausedOnQuestion ? 'show' : ''} />
        )}
        {isBeginning && player && (
          <Overlay
            className={`starting-fade ${isPausedOnQuestion ? 'show' : ''}`}
          />
        )}
        {!doneLoading && (
          <div>
            <IonSpinner id="video-loading" name="crescent" color="primary" />
          </div>
        )}
        <video
          ref={videoRef}
          className={`video-js ${
            !isBeginning && player && isPausedOnQuestion ? 'no-clicks' : ''
          }`}
        />
      </div>
      {user &&
        prompts &&
        Object.entries(prompts).map(([timestamp, prompt]: [any, any]) => {
          return (
            prompt && (
              <FocusScope key={timestamp}>
                <EpisodeVideoPrompt
                  closePrompt={closePrompt}
                  prompt={prompt}
                  user={user}
                />
              </FocusScope>
            )
          );
        })}
    </VideoWrapper>
  );
};
